import enCommon from './locales/en/common.json' with { type: 'json' };
import esCommon from './locales/es/common.json' with { type: 'json' };
import { deepMerge } from './deep-merge.js';
import { isSupportedLocale, readStoredLocale, } from './locale-config.js';
export const defaultLocale = 'en';
const resources = {
    en: { common: enCommon },
    es: { common: deepMerge(enCommon, esCommon) },
};
let activeLocale = resolveBootLocale();
function resolveBootLocale() {
    const stored = readStoredLocale();
    if (stored && stored in resources) {
        return stored;
    }
    return defaultLocale;
}
export function getLocale() {
    return activeLocale;
}
export function setActiveLocale(locale) {
    activeLocale = locale;
}
function lookup(bundle, path) {
    return path.split('.').reduce((acc, part) => {
        if (acc && typeof acc === 'object' && part in acc) {
            return acc[part];
        }
        return undefined;
    }, bundle);
}
export function t(key, locale = activeLocale) {
    const [namespace, ...rest] = key.split('.');
    const path = rest.join('.');
    const localeBundle = resources[locale]?.[namespace];
    const fromLocale = lookup(localeBundle, path);
    if (typeof fromLocale === 'string') {
        return fromLocale;
    }
    if (locale !== defaultLocale) {
        const fallbackBundle = resources[defaultLocale][namespace];
        const fromFallback = lookup(fallbackBundle, path);
        if (typeof fromFallback === 'string') {
            return fromFallback;
        }
    }
    return key;
}
export function getSupportedLocales() {
    return Object.keys(resources);
}
export function coerceLocale(value) {
    if (value && isSupportedLocale(value) && value in resources) {
        return value;
    }
    return defaultLocale;
}
//# sourceMappingURL=runtime.js.map